import { containerCss, textCss } from 'common/utils/styleUtilsNew'
import { SearchInputInterface } from 'src/shared/types/entities/search-interface'
import styled from 'styled-components'

export const SearchInputWrapperUi = styled.div`
  position: relative;
`

export const SearchInputUi = styled.input<SearchInputInterface>`
  border: none;
  width: 100%;
  transition: border 0.2s, box-shadow 0.2s;
  ${containerCss}
  ${textCss}

  &:focus {
    border: solid 1px #2563EB;
    box-shadow: 0px 0px 0px 4px #3B82F640;
    outline: none;
  }
`

export const SearchInputIconUi = styled.button`
  position: absolute;
  right: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  width: 38px;
  cursor: pointer;
  border: none;
  background: transparent;
`
